import { render, staticRenderFns } from "./PersistEmailDestinatarioView.vue?vue&type=template&id=275bccba&"
import script from "./PersistEmailDestinatarioView.vue?vue&type=script&lang=ts&"
export * from "./PersistEmailDestinatarioView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports